/**
 * Company Update Service
 * HTTP operations for company update
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { CompanyProfile } from '../types/companyProfile.types';
import { mapCompanyProfileToUpdateRequest } from '../mappers/companyUpdate.mapper';

/**
 * Service class for company update operations
 */
export class CompanyUpdateService {
  /**
   * Update company information
   * PUT /v{version}/companies/{companyId}
   * @param companyId - The company ID
   * @param profile - Company profile data
   */
  async updateInfo(companyId: number, profile: CompanyProfile): Promise<ApiResponse<void>> {
    const payload = mapCompanyProfileToUpdateRequest(profile);
    return apiClient.put<void>(API_CONFIG.ENDPOINTS.COMPANY.UPDATE(companyId), payload);
  }

  /**
   * Update company configuration
   * PUT /v{version}/companies/{companyId}
   * @param companyId - The company ID
   * @param profile - Company profile data
   */
  async updateConfig(companyId: number, profile: CompanyProfile): Promise<ApiResponse<void>> {
    const payload = mapCompanyProfileToUpdateRequest(profile);
    return apiClient.put<void>(API_CONFIG.ENDPOINTS.COMPANY.UPDATE(companyId), payload);
  }
}

export const companyUpdateService = new CompanyUpdateService();
